import { Typography } from "@mui/material";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { parseLinksAsDOMNode } from "@/src/components/Fields/CheckBox/components/CheckBox";

interface TextWithLinkProps {
    text: string;
    className?: string;
}

export function TextWithLink({ text, className }: Readonly<TextWithLinkProps>) {
    const convertedText = parseLinksAsDOMNode(text);

    return (
        <Typography
            className={cn(className)}
            sx={{
                fontSize: "15px",
                lineHeight: "22px",
            }}
        >
            {convertedText}
        </Typography>
    );
}